import React from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Alert from "@material-ui/lab/Alert";
import { connect, useSelector, useDispatch } from "react-redux";
import { Button, ButtonGroup, InputLabel, Switch } from '@material-ui/core';
import { ACTIONS_OF_APROVE, ACTIONS_ON_AFILIATE_RYA, ACTION_AFILIATE_COMPANY, CLOSE_MODALES, DEVOLUCIONES_FORM, DEVOLUCIONES_FORM_NAME, DOWMLOAD_DATA_TABLE_AFILIATIONS, HEADER_TABLE_PAGINATOR_REPORTS, INIT_SEARCH_FILTER_REPORT, OPEN_MODAL_DESCARGAR_DATOS, OPEN_REPORT_COMPLETION, PAGINAR_DATA_REPORTS, REGISTRO_AND_APORTES_FORM, REGISTRO_AND_APORTES_FORM_NAME, REPORTS_FORM_NAME, RETURN_HOME_BANDEJA, SEARCH_HISTORIAL_BANDEJA, TITLE_TABLE_PAGINATOR_REPORTS, panelReportsForm } from "./constants";
import { getConsultaPaginadaReports, getDataModalDatos, getDataReportsCompany, getDynamicDisable, getDynamicOptions, getIdFormulario, getMessageAlert, getMessageConfirmationRya, getOpenModalCharged } from "./selector";
import Customform from "../../components/materialform/customform";
import DataTableWithPaginator from '../../components/tableWithPaginator/tablePaginator';
import PrintConversationData from '../../components/printConversation/printConversation';
import { getFechaOfDate } from "../../controller/utils";


function Componet({ stepForm, setStepForm, stepFinal, itemsForm, anexos, catalog }) {
    const dispatch = useDispatch();
    const searchHistorial = (value) => dispatch({ type: SEARCH_HISTORIAL_BANDEJA, value });
    const actionsButtonsAprove = (value) => dispatch({ type: ACTIONS_ON_AFILIATE_RYA, value });
    const returnToHome = (value) => dispatch({ type: RETURN_HOME_BANDEJA, value });
    const savedActionsValidation = (value) => dispatch({ type: ACTION_AFILIATE_COMPANY, value });
    const closeModales = (value) => dispatch({ type: CLOSE_MODALES, value });
    const paginarDatosReports = (value) => dispatch({ type: PAGINAR_DATA_REPORTS, value });
    const searchFormFromTable = (value) => dispatch({ type: OPEN_REPORT_COMPLETION, value });
    const handleFilterReport = (value) => dispatch({ type: INIT_SEARCH_FILTER_REPORT, value });
    const abrirModalDescargarDatos = (value) => dispatch({ type: OPEN_MODAL_DESCARGAR_DATOS, value });
    const downloadCsv = (value) => dispatch({ type: DOWMLOAD_DATA_TABLE_AFILIATIONS, value });

    const idFormulario = useSelector(getIdFormulario);
    const messageConfirmation = useSelector(getMessageConfirmationRya);
    const dynamicOptions = useSelector(getDynamicOptions);
    const dynamicDisable = useSelector(getDynamicDisable);
    const dataReportsCompany = useSelector(getDataReportsCompany);
    const consultaPaginadaReports = useSelector(getConsultaPaginadaReports);
    const dataModalDatos = useSelector(getDataModalDatos);
    const openModalCharged = useSelector(getOpenModalCharged);
    const messageAlert = useSelector(getMessageAlert);


    const empleadorType = itemsForm && itemsForm.stepPrincipal ? itemsForm.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany : false;

    const modalConfirmacion = () => {
        return (
            <div >
                <Dialog
                    className="modal-confirmation"
                    open
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Información</DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="scroll-dialog-description"
                        //tabIndex={-1}
                        >
                            {messageConfirmation.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonGroup color="primary" aria-label="primary button group">
                            <Button
                                onClick={() => closeModales()}
                            >
                                Cancelar
                            </Button>


                            <Button onClick={() => savedActionsValidation({ messageConfirmation, itemsForm, anexos, catalog })}>
                                Aceptar
                            </Button>

                        </ButtonGroup>

                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    const validatePanelReports = (values) => {
        let errors = {
            informesCompanys: {}
        };
        if (values) {

            if (values.informesCompanys) {


                if (values.informesCompanys.dateStart && !values.informesCompanys.dateEnd) {
                    errors.informesCompanys["dateEnd"] = "Campo requerido";
                }

                let date = new Date();
                let fecha = getFechaOfDate(date)

                if (values.informesCompanys.dateStart) {
                    const fechaSis = Date.parse(getFechaOfDate(values.informesCompanys.dateStart));
                    if (
                        fechaSis < Date.parse("1900-01-01") ||
                        fechaSis > Date.parse(fecha)
                    ) {
                        errors.informesCompanys["dateStart"] = "Rango de fecha invalido";
                    }
                }

                if (values.informesCompanys.dateEnd) {
                    const fechaSisIni = Date.parse(getFechaOfDate(values.informesCompanys.dateStart));
                    const fechaSis = Date.parse(getFechaOfDate(values.informesCompanys.dateEnd));
                    if (
                        fechaSis < Date.parse("1900-01-01") ||
                        fechaSis > Date.parse(fecha) ||
                        fechaSis <= fechaSisIni
                    ) {
                        errors.informesCompanys["dateEnd"] = "Rango de fecha invalido";
                    }
                }



            }
        }
        return errors;
    }

    const modalSubmitValid = () => {

        return (
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                open
            >
                <div className="messageSucess">
                    <React.Fragment>
                        {messageAlert.error ? <Alert className="alert danger">
                            <p>{messageAlert.message}</p>
                        </Alert>
                            :
                            <Alert className="alertsucessBorrador" >
                                <p>{messageAlert.message}</p>
                            </Alert>
                        }
                    </React.Fragment>


                    <div>
                        <Button
                            className='buttonFinalizar'
                            color="default"
                            onClick={messageAlert.home ? () => returnToHome() : () => closeModales()}
                        >
                            Aceptar
                        </Button>
                    </div>


                </div>
            </Modal>
        );
    }

    const modalEsperaCharged = () => {

        return (
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                open
            >
                <div className="modalEsperaCharged">
                    <CircularProgress style={{ width: '70px', height: '70px' }} />
                </div>
            </Modal>
        );
    }

    return (

        <div className="Content-form-reports">

            <div className="Content-nav">
                <React.Fragment>
                    <Customform
                        submitable={false}
                        validations={validatePanelReports}
                        items={panelReportsForm(handleFilterReport)}
                        formName={REPORTS_FORM_NAME}
                        className="people-form"
                        dynamicOptions={dynamicOptions}
                        dynamicDisable={dynamicDisable}
                    />
                </React.Fragment>
            </div>

            <div className="Content-body">
                {openModalCharged ? modalEsperaCharged() : ""}
                {messageConfirmation ? modalConfirmacion() : ""}
                {messageAlert ? modalSubmitValid() : ""}
                <DataTableWithPaginator
                    className="people-inform-table"
                    data={dataReportsCompany}
                    columns={HEADER_TABLE_PAGINATOR_REPORTS} paginarData={paginarDatosReports}
                    //seleccionRangoBusqueda={this.state.seleccionRango}
                    searchFormFromTable={searchFormFromTable}
                    tituloTabla={TITLE_TABLE_PAGINATOR_REPORTS}
                    abrirModalDescargarDatos={abrirModalDescargarDatos}
                    modeSelection={"button"}
                    dataPaginada={dataReportsCompany} consultaPaginada={consultaPaginadaReports}
                    descargarCSV={downloadCsv} nombreConsulta={"convsPresupuesto"} dataToDownloadCsv={dataReportsCompany}
                //totalConvsFiltradas={dataReportsCompany}
                //convsToDownloadCsv={convsToDownloadCsv} 
                />
            </div>

            {dataModalDatos ?
                <PrintConversationData
                    datos={dataModalDatos}
                    cerrarModalDescargarDatos={closeModales}
                />
                : ""}
        </div>

    );
}

export const ComponetInformes = connect(
    null,
    null
)(Componet);